<app-admin-attachment-file-upload
  [allTermData]="allTermData$ | async"
  (outputOnUpload)="onUpload($event)"
  [fileUploadStatus]="fileUploadStatus"
></app-admin-attachment-file-upload>
